import { sniff } from '@/util'
import queryString from 'query-string'

// uboxApp中打开原生页面
const goPageView = function (url, isPageViewCallback = false, opentype = '') {
  const fixedUrl = queryString.stringifyUrl({
    url: url,
    query: {
      pageViewCallback: isPageViewCallback,
      opentype: opentype,
    },
  })
  if (sniff.isUboxAndroidApp) {
    window.app?.goPage && window.app?.goPage(fixedUrl)
  } else if (sniff.isUboxIosApp) {
    window?.webkit?.messageHandlers?.goPage && window?.webkit?.messageHandlers?.goPage.postMessage(fixedUrl)
  } else if( sniff.isWechatMiniProgram ){
    if ( opentype === 'H5back' ) {
      window.wx.miniProgram.reLaunch({
        url: fixedUrl,
      })
    } else {
      window.wx.miniProgram.navigateTo({
        url: `/pages/web-view-custom/web-view-custom?url=${encodeURIComponent(fixedUrl)}`,
      })
    }
  }
}

export default goPageView
